'use strict';

var core = require('@capacitor/core');

const PushNotifications = core.registerPlugin('PushNotifications', {});

exports.PushNotifications = PushNotifications;
//# sourceMappingURL=plugin.cjs.js.map
